function setLoading(state, { loading }) {
  state.loading = loading;
}

export default { setLoading };
